//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
	props: {
		modalTitle: {
			default: ''
		},
		modalSubTitle: {
			default: false
		},
		noPadding: {
			default: false
		},
		modalName: String,
		propertyOverride: {
			type: String
		}
	},

	data: function data() {
		return {
			showModal: false,
			title: '',
			subtitle: '',
			propertyName: null
		};
	},
	created: function created() {
		var _this = this;

		//allows modal to be dismissed on escape key
		document.addEventListener('keydown', function (e) {
			if (e.key == 'Escape' && _this.showModal) {
				Event.$emit('close-full-modal', _this.modalName);
			}
		});

		var $el = this;

		Event.$on('show-full-modal', function () {
			var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
			var subtitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			$el.showModal = true;

			// TODO: Clean this up.  I have no idea what is going on :)
			$el.title = $el.modalTitle;

			if ($el.modalSubTitle) {
				$el.subtitle = $el.modalSubTitle;
			} else {
				$el.subtitle = localStorage.getItem('property-name');
			}

			if (title) {
				$el.title = title;
			}

			if (subtitle) {
				$el.subtitle = subtitle;
			}
		});

		Event.$on('close-full-modal', function () {
			var modalName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

			// Adds ability to open a specific modal identified in modalName
			var $el = _this;
			if (modalName && modalName === _this.modalName || !modalName && !_this.modalName) {
				$el.showModal = false;
			}
		});
	},
	beforeDestroy: function beforeDestroy() {
		Event.$off('show-full-modal');
		// Event.$off('close-full-modal')
	},

	watch: {
		showModal: function showModal(newVal, oldVal) {
			if (newVal) {
				this.subtitle = localStorage.getItem('property-name');
			}
		}
	},
	updated: function updated() {
		this.title = this.modalTitle;
	},

	methods: {
		close: function close() {
			Event.$emit('close-full-modal', this.modalName);
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/layout/FullModal.vue
// module id = zUmK
// module chunks = 0 1